export const vehicleEquipmentFragment = `
  fragment VehicleEquipmentFragment on VehicleEquipment {
    equipmentId
    equipment {
      ...EquipmentFragment
    }
  }
`;
